/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { components } from "react-select";
import { Alter, AlterChangeFare, Bus, Car, CloseStops, Edit, Leave, Locality, LocalityStart, MapDis, MiddleSt, NearDots, OneWay, OneWaySvg, OpenStops, Reset, RoundTrip, RoundWaySvg, SavedRoute, SaveRoute, St, StEnd, StStart, Walk, Warn } from "../../common/svg/AllSvg";
import SelectComponent from "../../common/form/SelectComponent";
import PrimaryBtn from "../../common/form/PrimaryBtn";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useNavigate, useParams } from "react-router-dom";
import { dataActions } from "../../../shared/store/data-Slice";
import moment from "moment";

const Option: any = (props: any) => {
    return (
        <components.Option {...props}>{props.data.option}</components.Option>
    );
};

const PlanJouney = ({ edit, setEdit, journeyPlan, setJourneyPlan, setRouteData, routeData, fromStPh, setFromStPh, fromStSearch, setFromStSearch, toStSearch, setToStSearch, toStPh, setToStPh, fromErr, setFromErr, toErr, setToErr, fromSt, setFromSt, toSt, setToSt, submit, setSaveRoute, saveRoute, fromData, setFromData, tripLoading, saved, toData, setToData, getFavTrip, setType, type, setBookErr, downtime, setDownTime }: any) => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const isLogin: boolean = useSelector((state: any) => state.auth.isLogin);
    const [leave, setLeave] = useState<boolean>(true)
    const [viewStop, setViewStop] = useState<any>("");
    const [fromSts, setFromSts] = useState<any[]>([]);
    const [toSts, setToSts] = useState<any[]>([]);
    const [fromStOpen, setFromStOpen] = useState<any>(false);
    const [toStOpen, setToStOpen] = useState<any>(false);
    const [dateFocus, setDateFocus] = useState<boolean>(false)
    const [downtimeload, setDownTimeLoad] = useState<boolean>(true)
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!!!fromSt || !!!fromStSearch) {
            setFromStPh(t("passenger.home.banner.trip_planner.form.from_placeholder"))
        }
        if (!!!toSt || !!!toStSearch) {
            setToStPh(t("passenger.home.banner.trip_planner.form.to_placeholder"))
        }
    }, [lang])

    const handleFromInputChanged = (input: any, reason: any) => {
        if (
            reason.action === "set-value" ||
            reason.action === "input-blur" ||
            reason.action === "menu-close"
        ) {
            return;
        }

        const regex = /^[a-zA-Z0-9 ]*$/;

        if (regex.test(input) || input === '') {
            setFromStSearch(input);
            setFromStPh("")
            input !== fromSt?.label && setFromSt(null);
            input !== fromSt?.label && setJourneyPlan({ ...journeyPlan, from: '', fromName: '', fromType: '' })
        }
    };

    const handleToInputChanged = (input: any, reason: any) => {
        if (
            reason.action === "set-value" ||
            reason.action === "input-blur" ||
            reason.action === "menu-close"
        ) {
            return;
        }
        const regex = /^[a-zA-Z0-9 ]*$/;

        if (regex.test(input) || input === '') {
            setToStSearch(input);
            input !== toSt?.label && setToSt(null);
            input !== toSt?.label && setJourneyPlan({ ...journeyPlan, to: '', toName: '', toType: '' })
            setToStPh("")
        }
    };

    const handleFromChange = (e: any) => {
        fromSt = e;
        setFromSt(fromSt);
        !!fromSt && setFromErr(false)
        !!fromSt && setJourneyPlan({ ...journeyPlan, from: e?.code, fromName: e?.label, fromType: e?.type })
        setFromStOpen(false);
        !!fromSt ? setFromStSearch(e?.label) : setFromStSearch("")
    }

    const handleToChange = (e: any) => {
        toSt = e;
        setToSt(toSt);
        !!toSt && setToErr(false)
        !!toSt && setJourneyPlan({ ...journeyPlan, to: e?.code, toName: e?.label, toType: e?.type })
        setToStOpen(false);
        !!toSt ? setToStSearch(e?.label) : setToStSearch("");
    }

    const handleAlterChange = () => {
        const from: any = fromSt;
        const to: any = toSt;
        const fromSearch: any = fromStSearch;
        const toSearch: any = toStSearch;
        const fromType: any = fromSt?.type;
        const toType: any = toSt?.type;
        fromSt = to;
        setFromSt(fromSt);
        toSt = from;
        setToSt(toSt)
        setJourneyPlan({ ...journeyPlan, from: to?.code, to: from?.code, fromName: to?.label, toName: from?.label, fromType: toType, toType: fromType })
        !!to ? setFromStSearch(to?.label) : setFromStSearch(toSearch)
        !!from ? setToStSearch(from?.label) : setToStSearch(fromSearch);
        (!!!to && !!!toSearch) && setFromStPh(t("passenger.home.banner.trip_planner.form.from_placeholder"));
        (!!!from && !!!fromSearch) && setToStPh(t("passenger.home.banner.trip_planner.form.to_placeholder"));
    }

    const getFromStations = async () => {
        try {
            let apiUrl: any = ""
            if (!!fromStSearch) {
                apiUrl = await useAxios.get(`/${(!!lang ? lang : "en") + url?.searchStOrLt}${fromStSearch}/`);
            } else {
                apiUrl = await useAxios.get(`/${(!!lang ? lang : "en") + url?.searchStOrLt}`);
            }

            if (!!apiUrl) {
                const res: any = apiUrl;

                if (res && res?.status === 200) {
                    let stArr: any[] = res?.data[0]?.stations?.map((item: any) => ({
                        label: item?.name,
                        code: item?.code,
                        value: item?.code,
                        option: <div className="flex items-center">
                            <div className="pr-[8px]">
                                <St />
                            </div>
                            <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{item?.name}</p>
                        </div>,
                        type: "station",
                        id: item?.id
                    }))

                    let ltArr: any[] = res?.data[0]?.localities?.map((item: any) => ({
                        label: item?.name,
                        code: item?.name,
                        value: item?.name,
                        option: <div className="flex items-center">
                            <div className="pr-[8px]">
                                <Locality />
                            </div>
                            <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{item?.name}</p>
                        </div>,
                        type: "locality",
                        id: item?.id
                    }))

                    let arr: any[] = stArr.concat(ltArr)
                    setFromSts(arr)

                    if (!!!fromStSearch) {
                        setFromData(arr)
                    }

                    if (!!fromSt) {
                        let obj: any = arr?.find((item: any) => fromSt?.value === item?.value)
                        setFromSt(obj)
                        setFromStSearch(obj?.label)
                        setJourneyPlan({ ...journeyPlan, fromName: obj?.label })
                    }
                }
            }
        } catch (error) {
            console.error("error while feching stations or locality", error);
        }
    }

    useEffect(() => {
        !!lang && getFromStations();
    }, [lang, fromStSearch])

    useEffect(() => {
        fromStSearch?.length === 0 && setFromSts([])
    }, [fromStSearch])

    const getToStations = async () => {
        try {
            let apiUrl: any = ""
            if (!!toStSearch) {
                apiUrl = await useAxios.get(`/${(!!lang ? lang : "en") + url?.searchStOrLt}${toStSearch}/`);
            } else {
                apiUrl = await useAxios.get(`/${(!!lang ? lang : "en") + url?.searchStOrLt}`);
            }

            if (!!apiUrl) {
                const res: any = apiUrl;

                if (res && res?.status === 200) {
                    let stArr: any[] = res?.data[0]?.stations?.map((item: any) => ({
                        label: item?.name,
                        code: item?.code,
                        value: item?.code,
                        option: <div className="flex items-center">
                            <div className="pr-[8px]">
                                <St />
                            </div>
                            <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{item?.name}</p>
                        </div>,
                        type: "station",
                        id: item?.id
                    }))

                    let ltArr: any[] = res?.data[0]?.localities?.map((item: any) => ({
                        label: item?.name,
                        code: item?.name,
                        value: item?.name,
                        option: <div className="flex items-center">
                            <div className="pr-[8px]">
                                <Locality />
                            </div>
                            <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{item?.name}</p>
                        </div>,
                        type: "locality",
                        id: item?.id
                    }))

                    let arr: any[] = stArr.concat(ltArr)
                    setToSts(arr)
                    if (!!!toStSearch) {
                        setToData(arr)
                    }

                    if (!!toSt) {
                        let obj: any = arr?.find((item: any) => toSt?.value === item?.value)
                        setToSt(obj)
                        setToStSearch(obj?.label)
                        setJourneyPlan({ ...journeyPlan, toName: obj?.label })
                    }
                }
            }
        } catch (error) {
            console.error("error while feching stations or locality", error);
        }
    }

    useEffect(() => {
        !!lang && getToStations();
    }, [lang, toStSearch])

    useEffect(() => {
        toStSearch?.length === 0 && setToSts([])
    }, [toStSearch])

    const timeStringToDate = (timeString: any) => {
        const today = new Date();
        const [hours, minutes, seconds] = timeString.split(':').map(Number);
        today.setHours(hours, minutes, seconds, 0);
        return today;
    }

    const getDownTime = async () => {
        try {
            const res: any = await useAxios.get(`${url.metro_downtime}?lang=${(!!lang ? lang : "en")}`);

            if (res && res.status === 200) {
                setDownTime(res?.data)
                setDownTimeLoad(false)
            }
        } catch (error) {
            console.error("error while get metro time", error);
        }
    }

    useEffect(() => {
        !!lang && getDownTime()
    }, [lang])

    const handleNavigate = async (section: any) => {
        if (!!!fromSt && !!!toSt) {
            setFromErr(true)
            setToErr(true)
            return;
        }

        if (!!!fromSt) {
            setFromErr(true)
            return;
        }

        if (!!!toSt) {
            setToErr(true)
            return;
        }

        if (section === "map") {
            // &date=${journeyPlan?.date}
            if (params?.lang) {
                navigate(`/${params?.lang}/map?from=${fromSt?.code}&fromName=${fromSt?.label}&to=${toSt?.code}&toName=${toSt?.label}&fromType=${fromSt?.type}&toType=${toSt?.type}&date=${moment(new Date()).format('YYYY-MM-DDTHH:mm')}&journey=${(type === 1) ? "one_way" : "round_way"}`);
            } else {
                navigate(`/map?from=${fromSt?.code}&fromName=${fromSt?.label}&to=${toSt?.code}&toName=${toSt?.label}&fromType=${fromSt?.type}&toType=${toSt?.type}&date=${moment(new Date()).format('YYYY-MM-DDTHH:mm')}&journey=${(type === 1) ? "one_way" : "round_way"}`);
            }
        } else {
            if (isLogin) {
                let err: string = ""
                if (!!downtime) {
                    const specificDate = new Date(downtime?.metro_downtime_to);
                    const currentDate = new Date();
                    if (specificDate.getTime() > currentDate.getTime()) {
                        err = "soon"
                        setBookErr("soon")
                        return
                    }

                    const currentTime = new Date();
                    const startTime = timeStringToDate(downtime?.first_ticket_time);
                    const endTime = timeStringToDate(downtime?.last_ticket_time);

                    if (currentTime >= startTime && currentTime < endTime) { } else {
                        err = "hour"
                        setBookErr("hour")
                        return
                    }
                }

                if (!!err) return

                if (params?.lang) {
                    navigate(`/${params?.lang}/book-ticket?from=${(!!routeData?.localities && routeData?.localities[0]?.source_stn_localities?.length > 0) ? routeData?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.code : fromSt?.code}&fromName=${(!!routeData?.localities && routeData?.localities[0]?.source_stn_localities?.length > 0) ? routeData?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.name : fromSt?.label}&to=${(!!routeData?.localities && routeData?.localities[0]?.destination_stn_localities?.length > 0) ? routeData?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.code : toSt?.code}&toName=${(!!routeData?.localities && routeData?.localities[0]?.destination_stn_localities?.length > 0) ? routeData?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.name : toSt?.label}&fromType=station&toType=station&date=${journeyPlan?.date}&journey=${(type === 1) ? "one_way" : "round_way"}`);
                } else {
                    navigate(`/book-ticket?from=${(!!routeData?.localities && routeData?.localities[0]?.source_stn_localities?.length > 0) ? routeData?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.code : fromSt?.code}&fromName=${(!!routeData?.localities && routeData?.localities[0]?.source_stn_localities?.length > 0) ? routeData?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.name : fromSt?.label}&to=${(!!routeData?.localities && routeData?.localities[0]?.destination_stn_localities?.length > 0) ? routeData?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.code : toSt?.code}&toName=${(!!routeData?.localities && routeData?.localities[0]?.destination_stn_localities?.length > 0) ? routeData?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.name : toSt?.label}&fromType=station&toType=station&date=${journeyPlan?.date}&journey=${(type === 1) ? "one_way" : "round_way"}`);
                }
            } else {
                dispatch(dataActions.setLoginOpen(true))
            }
        }
    }

    const handleReset: any = () => {
        setFromStPh(t("passenger.home.banner.trip_planner.form.from_placeholder"))
        setToStPh(t("passenger.home.banner.trip_planner.form.to_placeholder"))
        setFromErr(false)
        setToErr(false)
        setFromSt(null)
        setToSt(null)
        setToStSearch("")
        setFromStSearch("")
        let obj: any = {
            from: '',
            fromName: '',
            to: '',
            toName: '',
            date: moment(new Date()).format('YYYY-MM-DDTHH:mm'),
            advanced: 'least-distance',
            fromType: '',
            toType: '',
            journey: "one_way"
        }
        Array.prototype.forEach.call(
            document.querySelectorAll(`.fromFlags div`),
            (item) => {
                item.style.visibility = 'hidden'
            }
        );
        Array.prototype.forEach.call(
            document.querySelectorAll(`.toFlags div`),
            (item) => {
                item.style.visibility = 'hidden'
            }
        );
        Array.from(document.querySelectorAll('.lines line')).forEach((line: any) => {
            line.style.stroke = line.__data__.color
        })
        Array.from(
            document.querySelectorAll(
                '.interchanges rect, .stations path'
            )
        ).forEach((interchange: any) => {
            interchange.style.stroke = '#1AD5FF'
            interchange.style.fill = "#DDDDDD"
        })
        Array.from(
            document.querySelectorAll(
                '.transferStations path'
            )
        ).forEach((interchange: any) => {
            interchange.style.stroke = '#1AD5FF'
            interchange.style.fill = "#DDDDDD"
        })
        setEdit(true)
        setRouteData(null)
        setJourneyPlan(obj)
        navigate(!!params?.lang ? `/${params?.lang}/map` : "/map")
    }

    const handleSaveTrip = async () => {
        if (isLogin) {
            try {
                setSaveRoute(true)
                let obj: any = {};
                let from: any = fromData?.find((item: any) => journeyPlan?.from === item?.value)
                let to: any = toData?.find((item: any) => journeyPlan?.to === item?.value)
                if (journeyPlan?.fromType === "station" && journeyPlan?.toType === "station") {
                    obj.from_station = from?.id
                    obj.to_station = to?.id
                }
                if (journeyPlan?.fromType === "locality" && journeyPlan?.toType === "locality") {
                    obj.from_locality = from?.id
                    obj.to_locality = to?.id
                }
                if (journeyPlan?.fromType === "station" && journeyPlan?.toType === "locality") {
                    obj.from_station = from?.id
                    obj.to_locality = to?.id
                }
                if (journeyPlan?.fromType === "locality" && journeyPlan?.toType === "station") {
                    obj.from_locality = from?.id
                    obj.to_station = to?.id
                }

                if (!!obj) {
                    const res: any = await useAxios.post(`/${(!!lang ? lang : "en") + url.mark_unmark_trip}`, obj);

                    if (res && (res.status === 201 || res.status === 204)) {
                        getFavTrip()
                        setSaveRoute(false)
                    }
                }
            } catch (error) {
                setSaveRoute(false)
                console.error("error while save trip", error);
            }
        } else {
            setSaveRoute(false)
            dispatch(dataActions.setLoginOpen(true))
        }
    }

    return (
        <div style={{ background: theme === "dark" ? "linear-gradient(180deg, #0A3A59 -2.05%, #2A2C38 129.39%)" : "linear-gradient(180deg, #FFD2DD -25.07%, #FFF 55.83%)" }} className="w-full mms:w-[380px] xlx:w-[430px] h-[520px] xlx:h-[570px] rounded-t-[20px] border-b-0 border border-[#E2E2E2] dark:border-[#313131] mms:order-1 order-2">
            {edit &&
                <form onSubmit={(e: any) => { e.preventDefault(); handleNavigate("map"); }} className="p-[12px] xs:px-[16px] xs:py-[18px] w-full h-full" noValidate>
                    <div className="bg-white dark:bg-bgDarkDull dark:border-[#5b5b5bcc] rounded-[20px] sm:p-[20px] p-[15px] flex flex-col border border-[#E2E2E2] min-h-[400px] relative">
                        <div className="flex items-center gap-[10px] z-[1]">
                            <button type="button" className={`${type === 1 ? "dark:bg-[#34384F] bg-white border dark:border-[#1361AA] border-[#9ACFFF] dark:text-textBlackDull text-primaryText" : "border dark:border-[#373d4a] border-[#8585855e] dark:bg-bgDarkDull bg-white text-[#858585] dark:text-white dark:text-opacity-[0.5]"} rounded-[10px] h-[30px] flex items-center gap-[8px] px-[10px] sm:px-[13px] font-semibold focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] dark:focus:shadow-[0_0_0_2px_#1361AA5e] dark:hover:shadow-[0_0_0_2px_#1361AA5e] text-sm leading-snug`} onClick={() => setType(1)}>
                                <OneWay className={`${type === 1 ? "fill-primaryText dark:fill-textBlackDull" : "fill-[#858585]"}`} />
                                <h5>{t("passenger.home.banner.trip_planner.one_way")}</h5>
                            </button>
                            <button type="button" className={`${type === 2 ? "dark:bg-[#34384F] bg-white border dark:border-[#1361AA] border-[#9ACFFF] dark:text-textBlackDull text-primaryText" : "border dark:border-[#373d4a] border-[#8585855e] dark:bg-bgDarkDull bg-white text-[#858585] dark:text-white dark:text-opacity-[0.5]"} rounded-[10px] h-[30px] flex items-center gap-[8px] px-[10px] sm:px-[13px] font-semibold focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] dark:focus:shadow-[0_0_0_2px_#1361AA5e] dark:hover:shadow-[0_0_0_2px_#1361AA5e] text-sm leading-snug`} onClick={() => setType(2)}>
                                <RoundTrip className={`${type === 2 ? "fill-primaryText dark:fill-textBlackDull" : "fill-[#858585]"}`} />
                                <h5>{t("passenger.home.banner.trip_planner.round_trip")}</h5>
                            </button>
                        </div>

                        <div className="flex flex-col mt-[15px] z-[1]">
                            <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("passenger.home.banner.trip_planner.form.title")}</h6>

                            <div className="flex flex-col mt-[10px] relative gap-[4.19px]">
                                <div className='flex flex-col'>
                                    <SelectComponent
                                        options={fromSts.filter(item => item?.code !== toSt?.code)}
                                        name="from"
                                        placeholder={fromStSearch || fromStPh}
                                        title={t("passenger.home.banner.trip_planner.form.from")}
                                        onFocus={() => setFromStPh("")}
                                        menuIsOpen={fromStOpen}
                                        onMenuOpen={() => setFromStOpen(true)}
                                        onMenuClose={() => setFromStOpen(false)}
                                        onBlur={() => { !!!fromStSearch && setFromStPh(t("passenger.home.banner.trip_planner.form.from_placeholder")) }}
                                        value={fromSt}
                                        onChange={(e: any) => handleFromChange(e)}
                                        inputValue={fromStSearch}
                                        onInputChange={handleFromInputChanged}
                                        components={{ Option }}
                                        arrow={false}
                                    />
                                </div>

                                <div className='flex items-center w-fit justify-end absolute right-0 top-[44px] pr-[35px] z-[1]'>
                                    <button title={t("aria_label.switch_st")} aria-label={t("aria_label.switch_st")} type="button" className='cursor-pointer min-w-[33px] min-h-[33px] xl:min-w-[36px] xl:min-h-[36px] rounded-full border border-[rgba(134,134,134,0.25)] dark:bg-[rgba(42,44,56,0.30)] bg-white flex items-center justify-center focus:shadow-[0_0_0_2px_#00376D5e] hover:shadow-[0_0_0_2px_#00376D5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e] backdrop-blur-[7px]' onClick={handleAlterChange}>
                                        <AlterChangeFare />
                                    </button>
                                </div>

                                <div className='flex flex-col'>
                                    <SelectComponent
                                        options={toSts.filter(item => item?.code !== fromSt?.code)}
                                        name="to"
                                        placeholder={toStSearch || toStPh}
                                        title={t("passenger.home.banner.trip_planner.form.to")}
                                        onFocus={() => setToStPh("")}
                                        menuIsOpen={toStOpen}
                                        onMenuOpen={() => setToStOpen(true)}
                                        onMenuClose={() => setToStOpen(false)}
                                        onBlur={() => { !!!toStSearch && setToStPh(t("passenger.home.banner.trip_planner.form.to_placeholder")) }}
                                        value={toSt}
                                        onChange={(e: any) => handleToChange(e)}
                                        inputValue={toStSearch}
                                        onInputChange={handleToInputChanged}
                                        components={{ Option }}
                                    />
                                </div>
                            </div>

                            {/* ${dateFocus && "shadow-lg bg-white"} hover:shadow-lg hover:bg-white */}
                            {/* <div className='mt-[15px]'>
                                <div className={`w-full xsm:w-[250px] rounded-[10px] border border-[rgba(134,134,134,0.25)] bg-[#F8F8F8] dark:bg-[#191919] flex flex-col px-[12px] sm:px-[17px] pt-[8px]`} >
                                    <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("passenger.home.banner.trip_planner.form.departure")}</h6>
                                    {leave ?
                                        <button type="button" className="w-full flex items-center justify-between gap-[8px] mt-[-4px] disabled:opacity-[0.7] disabled:cursor-not-allowed" disabled onFocus={() => { setLeave(false); setDateFocus(true) }} onClick={() => { setLeave(false); setDateFocus(false) }} >
                                            <h4 className="text-primaryText dark:text-textBlackDull font-semibold h-[32px] xlx:h-[35px] flex items-center">{t("passenger.home.banner.trip_planner.form.leaving_now")}</h4>
                                            <div className="mb-[2px]">
                                                <Leave className="fill-[#1c1b1f4d] dark:fill-textBlackDull" />
                                            </div>
                                        </button>
                                        :
                                        <div className="w-full flex items-center justify-between gap-[8px] mt-[-4px]">
                                            <input
                                                title=""
                                                type="datetime-local"
                                                id="datepicker"
                                                name="datetime-picker"
                                                value={journeyPlan?.date}
                                                onChange={(e: any) => setJourneyPlan({ ...journeyPlan, date: e.target.value })}
                                                className="w-full h-[32px] xlx:h-[35px] font-semibold text-lg text-primaryText dark:text-textBlackDull !bg-transparent custom-date-input"
                                                min={moment(new Date()).format('YYYY-MM-DDTHH:mm')}
                                                onFocus={() => setDateFocus(true)}
                                                onBlur={() => setDateFocus(false)}
                                                autoFocus
                                                autoComplete=""
                                            />
                                        </div>
                                    }
                                </div>
                                {(fromErr || toErr) && <div className="flex gap-[6px] items-start mt-[4px]"><Warn />
                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("passenger.home.fare.err")}</span>
                                </div>}
                            </div> */}
                        </div>

                        <div className="flex items-center justify-between w-full mt-[30px] z-[1]">
                            <button type="button" className="flex items-center justify-center gap-[7px] text-danger dark:text-darkDanger font-bold uppercase disabled:opacity-[0.5] disabled:cursor-not-allowed focus:shadow-[0_0_0_2px_#ff00005e] hover:shadow-[0_0_0_2px_#ff00005e] focus:rounded-[4px] hover:rounded-[4px] disabled:rounded-none disabled:shadow-none disabled:dark:shadow-none py-[1px] px-[6px] dark:focus:shadow-[0_0_0_2px_#FF5B5B5e] dark:hover:shadow-[0_0_0_2px_#FF5B5B5e] text-sm leading-snug" disabled={(!!fromStSearch || !!toStSearch) ? false : true} onClick={handleReset}><Reset /> <span className="pt-[2px]">{t("passenger.home.banner.trip_planner.form.reset")}</span></button>
                            <PrimaryBtn title={t("passenger.home.banner.trip_planner.form.plan_journey")} onClick={() => handleNavigate("map")} disabled={submit} />
                        </div>

                        <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full flex items-end justify-end z-[0]">
                            <img src={require("../../../assets/images/planjourney-bg1.png")} alt="planjourney-bg" className="rounded-b-[20px] w-full dark:sepia" />
                        </div>
                    </div>
                </form>
            }

            {((!!routeData && Object.keys(routeData)?.length > 0) && !edit) && <div className="w-full py-[12px] xs:py-[18px] h-full">
                <div className="px-[12px] xs:px-[16px] w-full">
                    <div className="bg-[#ffffffcc] dark:bg-[#272934cc] rounded-[20px] p-[15px]">
                        <div className="flex items-center gap-[12px] w-full border-b border-[#059db233] dark:border-[#0d566033] pb-[11px]">
                            <h6 className="font-semibold text-primaryText dark:text-textBlackDark text-center w-full">{(!!routeData?.localities && routeData?.localities?.[0]?.source_stn_localities?.length > 0) ? routeData?.localities[0]?.source_stn_localities[0]?.name : routeData?.from}
                            </h6>
                            <div aria-label={type === 1 ? t("aria_label.one_way") : t("aria_label.round_way")} title={type === 1 ? t("aria_label.one_way") : t("aria_label.round_way")} className="min-w-[26px]">
                                {type === 1 ? <OneWaySvg /> : <RoundWaySvg />}
                            </div>
                            {/* <Alter /> */}
                            <h6 className="font-semibold text-primaryText dark:text-textBlackDark text-center w-full">{(routeData?.localities && routeData?.localities?.[0]?.destination_stn_localities?.length > 0) ? routeData?.localities[0]?.destination_stn_localities[0]?.name : routeData?.to}</h6>
                        </div>

                        <div className="border-b border-[#059db233] dark:border-[#0d566033] py-[10px] flex items-center justify-between w-full px-[10px]">
                            <div className="flex gap-[15px] xlx:gap-[20px]">
                                <div className="flex items-center gap-[8px]">
                                    <MapDis />
                                    <div className="flex flex-col">
                                        <h6 className="text-blackDull dark:text-textBlackDull font-semibold text-opacity-[0.9]">{t("passenger.home.fare.detail.distance")}</h6>
                                        <h6 className="text-primaryText dark:text-white font-bold uppercase">{!!routeData?.distance ? parseFloat(routeData?.distance?.replace(" km", "")).toFixed(2) : "0"} {t("passenger.home.fare.detail.km")}</h6>
                                    </div>

                                </div>

                                {/* <div className="flex items-center gap-[8px]">
                                    <MapTime />
                                    <div className="flex flex-col">
                                        <h6 className="text-blackDull dark:text-textBlackDull font-semibold text-opacity-[0.9]">{t("passenger.home.fare.detail.est_time")}</h6>
                                        <h6 className="text-primaryText dark:text-white font-bold uppercase">{(Math.round(moment.duration(routeData?.total_time).asMinutes())) || 0} {t("passenger.home.fare.detail.min")}</h6>
                                    </div>
                                </div> */}
                            </div>

                            <h3 className="text-primaryText dark:text-white font-bold">₹ {!!routeData?.fare ? routeData?.fare : "0"}</h3>
                        </div>

                        <div className="w-full flex items-center justify-between pt-[15px] flex-wrap gap-[6px]">
                            {tripLoading ? <div className="h-[30px] bg-gray-200 rounded-[8px] dark:bg-gray-700 w-[100px]"></div>
                                : <button type="button" className="text-sm leading-tight text-primary font-semibold flex items-center justify-center px-[9px] w-fit gap-[5px] rounded-[8px] h-[30px] border border-primary bg-[#FAFAFA] dark:bg-bgDarkDull disabled:opacity-[0.5] disabled:cursor-not-allowed focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] disabled:shadow-none disabled:hover:shadow-none whitespace-nowrap" disabled={saveRoute} onClick={handleSaveTrip}>
                                    {!saved ? <SaveRoute className="min-w-[16px]" /> : <SavedRoute className="min-w-[18px]" />}
                                    {!saved ? t("passenger.map.save_route") : t("passenger.map.saved")}
                                </button>}

                            <div className="flex items-center gap-[6px]">
                                {downtimeload ?
                                    <div className="h-[30px] bg-gray-200 rounded-[8px] dark:bg-gray-700 w-[110px]"></div>
                                    : <SecondaryBtn type="button" css="!h-[30px] px-[15px] xs:px-[20px] text-sm font-semibold !rounded-[10px] whitespace-nowrap" title={t("passenger.map.book_ticket")} onClick={() => handleNavigate("book-ticket")} disabled={(+parseInt(routeData?.fare)?.toFixed()) === 0 ? true : false} />}
                                <button aria-label={t("aria_label.edit")} title={t("aria_label.edit")} type="button" className="flex items-center justify-center min-w-[30px] rounded-[8px] h-[30px] border border-primary bg-[#FAFAFA] dark:bg-bgDarkDull focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" onClick={() => setEdit(true)}>
                                    <Edit className="w-[16px] h-[16px] fill-primary" />
                                </button>
                            </div>
                        </div>

                        {/* {!validBooking && <div className="flex gap-[6px] items-center justify-end pt-[8px]"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium leading-tight xlx:leading-normal">{t("passenger.map.book_ticket_sec.valid_booking")}</span>
                        </div>} */}
                    </div>
                </div>


                <div className="w-full flex flex-col gap-[25px] h-[calc(100%-180px)] overflow-y-auto mt-[13px]">
                    {(!!routeData?.localities && routeData?.localities?.[0]?.source_stn_localities?.length > 0) && <>
                        <div className="flex items-center gap-[12px] px-[30px]">
                            <LocalityStart />
                            <h4 className="text-blackDark dark:text-textBlackDark font-bold">{routeData?.localities[0]?.source_stn_localities[0]?.name}
                            </h4>
                        </div>

                        <div className="flex items-center w-full justify-between gap-[15px] px-[30px]">
                            <div className="flex items-center gap-[20px] pl-[8px]">
                                <NearDots />

                                <div className="flex flex-col gap-[2px]">
                                    <h5 className="text-primaryText dark:text-white font-bold">
                                        {t("passenger.map.towards_st")}
                                        {/* | 4min */}
                                    </h5>
                                    <h6 className="text-blackDark dark:text-textBlackDark font-semibold" dangerouslySetInnerHTML={{ __html: routeData?.localities[0]?.source_stn_localities[0]?.transport_detail_from }} />
                                </div>
                            </div>

                            <div className="flex items-center gap-[8px]">
                                {Array.isArray(routeData?.localities[0]?.source_stn_localities[0]?.transport_mode_from) && routeData?.localities[0]?.source_stn_localities[0]?.transport_mode_from?.map((item: any, index: number) => (
                                    <React.Fragment key={index}>
                                        {item?.name?.toLowerCase() === "walk" && <div className="min-w-[28px] h-[28px] rounded-full flex items-center justify-center border border-[#EFEFEF] shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12)]">
                                            <Walk />
                                        </div>}
                                        {item?.name?.toLowerCase() === "bus" && <div className="min-w-[28px] h-[28px] rounded-full flex items-center justify-center border border-[#EFEFEF] shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12)]">
                                            <Bus />
                                        </div>}
                                        {item?.name?.toLowerCase() === "car" && <div className="min-w-[28px] h-[28px] rounded-full flex items-center justify-center border border-[#EFEFEF] shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12)]">
                                            <Car />
                                        </div>}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </>}

                    <div className="flex flex-col gap-[15px]">
                        {Array.isArray(routeData?.route) && routeData?.route?.map((item: any, index: number) => (
                            <div className={`${((!!routeData?.localities && routeData?.localities[0]?.source_stn_localities?.length > 0) || (!!routeData?.localities && routeData?.localities[0]?.destination_stn_localities?.length > 0)) ? "bg-[#D9D9D933] dark:bg-[#43434333]" : ""} flex gap-[12px] px-[30px]`} key={index}>
                                <div className={`flex flex-col items-center justify-center ${((!!routeData?.localities && routeData?.localities[0]?.source_stn_localities?.length > 0) || (!!routeData?.localities && routeData?.localities[0]?.destination_stn_localities?.length > 0)) ? "pt-[20px] pb-[43.5px]" : "pt-[7px] pb-[4px] "}`}>
                                    {(!!routeData?.localities && routeData?.localities[0]?.source_stn_localities?.length > 0) ? <StStart /> : <LocalityStart />}
                                    <div className="w-[5px] h-full bg-primary mb-[-1px] mt-[-1px]"></div>
                                    {(!!routeData?.localities && routeData?.localities[0]?.destination_stn_localities?.length > 0) ? <StStart /> : <StEnd />}
                                </div>

                                <div className={`flex flex-col ${((!!routeData?.localities && routeData?.localities[0]?.source_stn_localities?.length > 0) || (!!routeData?.localities && routeData?.localities[0]?.destination_stn_localities?.length > 0)) ? "pb-[40px] pt-[20px] " : "pt-[7px] "}`}>
                                    <div className="flex flex-col gap-[2px]">
                                        <h4 className="text-blackDark dark:text-textBlackDark font-bold">{item?.start}
                                        </h4>
                                        <p className="text-blackDark dark:text-textBlackDark font-semibold">{!!item?.platform_name ? item?.platform_name : routeData?.platforms?.[0]?.platform_name}</p>
                                    </div>

                                    {item?.path?.length > 2 && <div className="flex items-center gap-[7px] pt-[15px]">
                                        <button aria-label={viewStop === (index + 1) ? t("aria_label.close_stop") : t("aria_label.open_stop")} title={viewStop === (index + 1) ? t("aria_label.close_stop") : t("aria_label.open_stop")} type="button" onClick={() => (index + 1) !== viewStop ? setViewStop((index + 1)) : setViewStop("")} className="focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] rounded-full">
                                            {viewStop === (index + 1) ? <OpenStops /> : <CloseStops />}
                                        </button>
                                        <h6 className="text-primaryText dark:text-white font-extrabold pt-[1px] uppercase">{item?.path?.length - 2} {t("passenger.map.stops")}</h6>
                                        {/* <div className="h-[13px] w-[1px] bg-blackDull mt-[1px]"></div>
                                        <h6 className="text-blackDark dark:text-textBlackDark font-extrabold pt-[1px] uppercase">{(Math.round(moment.duration(routeData?.total_time).asMinutes())) || 0} {t("passenger.home.fare.detail.min")}</h6> */}
                                    </div>}

                                    {viewStop === (index + 1) && <div className='flex flex-col pt-[15px] gap-[20px]'>
                                        {Array.isArray(item?.path) && item?.path?.map((i: any, idx: number) => (
                                            <div className={`relative ${(idx === 0 || (item?.path?.length === idx + 1)) && "hidden"}`} key={idx}>
                                                <div className="absolute top-[4px] left-[-26px]"><MiddleSt /></div>
                                                <p className='font-semibold text-blackDark dark:text-textBlackDark'>{i?.name}</p>
                                            </div>
                                        ))}
                                    </div>}

                                    <div className="flex flex-col gap-[2px] pt-[30px]">
                                        <h4 className="text-blackDark dark:text-textBlackDark font-bold">{item?.path[item?.path?.length - 1]?.name}
                                        </h4>
                                        <p className="text-blackDark dark:text-textBlackDark font-semibold">{!!item?.platform_name ? item?.platform_name : routeData?.platforms?.[0]?.platform_name}</p>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>

                    {(routeData?.localities && routeData?.localities?.[0]?.destination_stn_localities?.length > 0) && <>
                        <div className="flex items-center w-full justify-between gap-[15px] px-[30px]">
                            <div className="flex items-center gap-[20px] pl-[8px]">
                                <NearDots />

                                <div className="flex flex-col gap-[2px]">
                                    <h5 className="text-primaryText dark:text-white font-bold">
                                        {t("passenger.map.towards_dest")}
                                        {/* | 4min */}
                                    </h5>
                                    <h6 className="text-blackDark dark:text-textBlackDark font-semibold" dangerouslySetInnerHTML={{ __html: routeData?.localities[0]?.destination_stn_localities[0]?.transport_detail_to }} />
                                </div>
                            </div>

                            <div className="flex items-center gap-[8px]">
                                {Array.isArray(routeData?.localities[0]?.destination_stn_localities[0]?.transport_mode_to) && routeData?.localities[0]?.destination_stn_localities[0]?.transport_mode_to?.map((item: any, index: number) => (
                                    <React.Fragment key={index}>
                                        {item?.name?.toLowerCase() === "walk" && <div className="min-w-[28px] h-[28px] rounded-full flex items-center justify-center border border-[#EFEFEF] shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12)]">
                                            <Walk />
                                        </div>}
                                        {item?.name?.toLowerCase() === "bus" && <div className="min-w-[28px] h-[28px] rounded-full flex items-center justify-center border border-[#EFEFEF] shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12)]">
                                            <Bus />
                                        </div>}
                                        {item?.name?.toLowerCase() === "car" && <div className="min-w-[28px] h-[28px] rounded-full flex items-center justify-center border border-[#EFEFEF] shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12)]">
                                            <Car />
                                        </div>}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>

                        <div className="flex items-center gap-[12px] px-[30px]">
                            <StEnd />
                            <h4 className="text-blackDark dark:text-textBlackDark font-bold">{routeData?.localities[0]?.destination_stn_localities[0]?.name}
                            </h4>
                        </div>
                    </>}

                </div>

            </div>}
        </div>
    );
};

export default PlanJouney;